/* eslint-disable no-unused-vars */
import {API_URL} from '../constants/index.js';
import {
    ROOM,
    ROOM_SUCCESS,
    ROOM_ERROR,
    ADD_ROOM,
    ADD_ROOM_SUCCESS,
    ADD_ROOM_ERROR,
    UPDATE_ROOM,
    UPDATE_ROOM_SUCCESS,
    UPDATE_ROOM_ERROR,
    DELETE_ROOM,
    DELETE_ROOM_ERROR,
    DELETE_ROOM_SUCCESS,
    ROOM_ITEM,
    ROOM_ITEM_SUCCESS,
    ROOM_ITEM_ERROR
} from '../constants/roomConstant.js';

import {sweetAlert} from '../components/Alert/sweetAlert'


//#region ROOM (ALL - BYID)
export function getroom(data) {
    return {
        type: ROOM,
        data
    }
}

export function getroomSuccess(data) {
    return {
        type: ROOM_SUCCESS,
        data
    }
}

export function getroomError(data) {
    return {
        type: ROOM_ERROR,
        data
    }
}

export function getAllRooms(data) {
    return dispatch => {
        dispatch(getroom());
        fetch(API_URL+'rooms/rooms',
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getroomSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getroomError(error));
            })
    }
}
export function getRoomsByCommunityId(communityId, includeCommonRooms, sort) {
    return dispatch => {
        dispatch(getroom());
        fetch(API_URL+'rooms/roomsbycommunityid/' + communityId,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token'),
                    'includeCommonRooms': includeCommonRooms,
                    'sort': sort === true ? 1 : -1
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getroomSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getroomError(error));
            })
    }
}

export function getRoomById(id) {
    return dispatch => {
        dispatch(getroom());
        fetch(API_URL+'rooms/rooms/' + id,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getroomSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getroomError(error));
            })
    }
}

//#endregion


//#region ADD ROOM

    export function newroom(data) {
        return {
            type: ADD_ROOM,
            data
        }
    }

    export function newroomSuccess(data) {
        return {
            type: ADD_ROOM_SUCCESS,
            data
        }
    }

    export function newroomError(data) {
        return {
            type: ADD_ROOM_ERROR,
            data
        }
    }

    export function addRoom(data) {
        return dispatch => {
            dispatch(newroom());
            fetch(API_URL+'rooms/rooms',
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json' ,
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                }
                })
                .then(res => {
                    dispatch(newroomSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The element ${data.name} has been added successfully`

                    sweetAlert('success',message,'alert_AddRoom_Success');
                })
                .catch(error => {
                    dispatch(newroomError(error));

                    const message = `An error occurred when trying to add the room ${data.name} `

                    sweetAlert('error',message,'alert_AddRoom_Error');
                })
        }
    }

    export function addRoomByCommunity(data, communityId, objStyles) {
        return dispatch => {
            dispatch(newroom());
            fetch(API_URL+'/rooms/addroombycommunityid/'+communityId,
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json' ,
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                }
                })
                .then(res => {
                    dispatch(newroomSuccess(res));
                    return res;
                })
                .then( () =>{
                    const message = `The element ${data.name} has been added successfully`

                    sweetAlert('success',message, 'alert_AddRoomByCommunity_Success', objStyles);
                })
                .catch(error => {
                    dispatch(newroomError(error));

                    const message = `An error occurred when trying to add the room ${data.name} `

                    sweetAlert('error',message, 'alert_AddRoomByCommunity_Error', objStyles);
                })
        }
    }

//#endregion

//#region UPDATE ROOM

    export function modRoom(data) {
        return {
            type: UPDATE_ROOM,
            data
        }
    }

    export function modRoomSuccess(data) {
        return {
            type: UPDATE_ROOM_SUCCESS,
            data
        }
    }

    export function modRoomError(data) {
        return {
            type: UPDATE_ROOM_ERROR,
            data
        }
    }

    export function updRoom(id, data, objStyles) {
        
        return dispatch => {
            dispatch(modRoom());
            fetch(API_URL+'rooms/rooms/'+ id,
                {
                    method: 'PUT',
                    body: JSON.stringify(data),
                    headers: { 
                        'Content-Type':'application/json' ,
                        'Cache-Control': 'no-cache, no-store, must-revalidate',
                        'Authorization': 'Bearer '+localStorage.getItem('token')
                }
                })
                .then(res => {
                    dispatch(modRoomSuccess(res));
                    return res;
                })
                .then( () =>{

                    const message = `The element ${data.name} has been updated successfully`

                    sweetAlert('success',message, 'alert_UpdateRoom_Success', objStyles);
                })
                .catch(error => {
                    dispatch(modRoomError(error));

                    const message = `An error occurred when trying to update the room ${data.name} `

                    sweetAlert('error',message, 'alert_UpdateRoom_Error', objStyles);
                })
        }
    }

//#endregion

//#region DELETE ROOM

export function deleteRoom(data) {
    return {
        type: DELETE_ROOM,
        data
    }
};

export function deleteRoomSuccess(data) {
  
    return {
        type: DELETE_ROOM_SUCCESS,
        data
    }
};

export function deleteRoomError(data) {
    return {
        type: DELETE_ROOM_ERROR,
        data
    }
};

export function delRoom(id, data) {
    return dispatch => {
        
        dispatch(deleteRoom());
        
        fetch(API_URL+'rooms/rooms/'+ id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(deleteRoomSuccess(id));
                return res;
            })
            .then( () =>{
                const message = `The element has been deleted successfully`

                sweetAlert('success',message, 'alert_DeleteRoom_Success');
            })
            .catch(error => {
                dispatch(deleteRoomError(error));

                const message = `An error occurred when trying to update the room `

                sweetAlert('error',message, 'alert_DeleteRoom_Error');
            })
    }
};


export function delRoomByCommunity(id, objStyles) {
    return dispatch => {
        
        dispatch(deleteRoom());
        
        fetch(API_URL+'rooms/delroomcommunity/'+ id,
            {
                method: 'DELETE',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => {
                dispatch(deleteRoomSuccess(id));
                return res;
            })
            .then( () =>{
                const message = `The room has been deleted successfully`

                sweetAlert('success',message, 'alert_DeleteRoomByCommunity_Success', objStyles);
            })
            .catch(error => {
                dispatch(deleteRoomError(error));

                const message = `An error occurred when trying to delete the room `

                sweetAlert('error',message, 'alert_DeleteRoomByCommunity_Error', objStyles);
            })
    }
};


//#endregion

//#REGION ROOM-ITEMS

function getRoomItem(data) {
    return {
        type: ROOM_ITEM,
        data
    }
}

function getRoomItemSuccess(data) {
    return {
        type: ROOM_ITEM_SUCCESS,
        data
    }
}

function getRoomItemError(data) {
    return {
        type: ROOM_ITEM_ERROR,
        data
    }
}

export function getRoomItemsByCommunityId(communityId) {
    return dispatch => {
        dispatch(getRoomItem());
        fetch(API_URL+'/rooms/roomsItems/' + communityId,
            {
                method: 'GET',
                headers: { 
                    'Content-Type':'application/json' ,
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer '+localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getRoomItemSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getRoomItemError(error));
            })
    }
}

//#ENDREGION
